import React from 'react';
import { CuratorshipItemsListInput, type CuratorshipItem } from './CuratorshipItemsListInput';

interface CuratorshipItemsFieldProps {
  label: string;
  required?: boolean;
  value: CuratorshipItem[];
  onChange: (_items: CuratorshipItem[]) => void;
  error?: string;
}

export const CuratorshipItemsField: React.FC<CuratorshipItemsFieldProps> = ({
  label,
  required,
  value,
  onChange,
  error,
}) => {
  return (
    <div className="space-y-2">
      <label className="block text-sm font-medium text-gray-700">
        {label}
        {required && <span className="text-red-500 ml-1">*</span>}
      </label>
      <CuratorshipItemsListInput value={value} onChange={onChange} />
      {error && <p className="text-red-500 text-sm">{error}</p>}
    </div>
  );
};
